import { Link } from '@remix-run/react'
import React, { useState } from 'react'
import { Button } from './ui/button.tsx'

export const CookieConsentBanner = () => {
	const [showBanner, setShowBanner] = useState(false)

    React.useEffect(() => {
        const cookieValue = getConsentCookie("cookieConsent");
        if (!cookieValue) {
            setShowBanner(true);
        }
    }, []);

    const setThirdPartyCookie = (name: string, value: any, days: number) => {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        // Set the cookie with the SameSite=None and Secure attributes
        document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=None; Secure";
    }

    const getConsentCookie = (name: string) => {
        const value = "; " + document.cookie;
        const parts = value.split("; " + name + "=");
        if (parts.length === 2) return parts.pop()?.split(";").shift();
    }

    const acceptCookies = () => {
        setThirdPartyCookie('cookieConsent', 'accepted', 365);
        setShowBanner(false);
        // Here, you can also load 3rd party scripts if needed
    };

    const declineCookies = () => {
        setThirdPartyCookie('cookieConsent', 'declined', 365);
        setShowBanner(false);
    };

	if (!showBanner) {
		return null
	}

	return (
		<div className="fixed bottom-0 left-0 w-full bg-gray-900 p-4 text-white">
			<div className="container mx-auto flex items-center justify-between">
				<div>
					We use third-party cookies to enhance user experience and analyze
					website traffic.
					<Link to="/cookies" className="ml-2 text-blue-400 underline">
						Learn more
					</Link>
				</div>
				<div>
					<Button
						onClick={acceptCookies}
						className="mr-2 rounded bg-blue-500 px-4 py-2 text-white"
					>
						Accept
					</Button>
					<Button
						onClick={declineCookies}
						className="rounded bg-transparent px-4 py-2 text-white"
					>
						Decline
					</Button>
				</div>
			</div>
		</div>
	)
}
